import React from 'react';
import { createUseStyles } from 'react-jss';
import PropTypes from 'prop-types';

const RegularPopover = (props) => {
  const styles = useStyles();
  const { title, description, } = props;

  return (
    <>
      <h4 className={styles.title}>{title}</h4>
      <span className={styles.description}>{description}</span>
    </>
  );
};

const useStyles = createUseStyles({
  title: {
    marginBottom: 10,
    fontSize: 16,
    fontWeight: 500,
    lineHeight: '25px',
    color: '#6F6C77',
  },
  description: {
    fontWeight: 500,
  },
});

RegularPopover.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
}

export default RegularPopover;
